export default "__VITE_ASSET__6e6f62a0__"